import React from 'react';

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import axios from 'axios';
import SheetMusicPlayer from './SheetMusicPlayer.js';
import settingSystem from "../SettingSystem.js"

import TextManager from '../TextManager.js';
import cbor from 'cbor-js';

export default class ScoreProcessingProgressManager extends React.Component {

	state = {
        showProcessingDialog: false,
		progressText: "",
		progressPageNumber: undefined,
		progressStepPercentage: undefined,
		progressTotalPercentage: undefined,

        errorMessage: null,
        newScoreConfirmDialogOpened: false,
		
    }

	newScoreConfirmDialogResolver = null;
    
	sendProcessingRequest = async (endpoint, formData) => {
		SheetMusicPlayer.singleton.stop();

		if(! await this.waitForNewScoreConfirmDialog()){
			return false;
		}

		this.setState({
			showProcessingDialog: true
		});

		try {

			formData.append("mergeTracks", settingSystem.getSetting("mergeTracksOption"));
			formData.append("usePreprocessing", settingSystem.getSetting("usePreprocessing"))

			this.setState({ progressText: TextManager.getText("score_process_starting") })

			const res = await axios.post(endpoint, formData,
				{
					headers: { 'content-type': 'multipart/form-data' },
					//responseType: 'arraybuffer'
				}
			);

			const batchName = res.data.batchName

			const timeout = Date.now() + 100 * 60 * 1000; //5 min timeout TODO: should be config?
			const pollDelay = 1500;
			const maxErrorCount = 20;
			let errorCount = 0;


			while (Date.now() < timeout) {
				try {
					const pollRes = await axios.post(`/api/omr-poll-result`, { batchName: batchName },
						{
							headers: { "Content-Type": "application/json" },
							responseType: 'arraybuffer'
						}
					);
					let data = cbor.decode(pollRes.data);
					//console.log(data);
					this.setState({
						progressText: this.getProgressText(data),
						progressPageNumber: data.page,
						progressStepPercentage: data.stepPercentage,
						progressTotalPercentage: data.totalPercentage,
					})
					if (data.status === "error") {
						//console.log(data);
						this.setState({ errorMessage: TextManager.getText("score_process_failed") })
						//alert(error) //TODO: proper error handling
						return false;
					}

					if (data.status === "success") {
						if (data.warnings && data.warnings.find(w => w.id === "multiple_score_detected")) {
							//alert("Warning: multiple scores are dectected, only the first score will be used.")
							this.setState({ errorMessage: TextManager.getText("score_process_multiple_scores_error") })
						}
						await SheetMusicPlayer.singleton.loadData(data);
						return true;
					}
				}
				catch (error) {
					console.log(error);
					errorCount++
					if (errorCount > maxErrorCount) {
						throw new Error("connection_error")
					}
				}

				await new Promise(resolve => setTimeout(resolve, pollDelay));

			}

			throw new Error("processing_timeout")

		} catch (error) {
			console.log(error);
			if (error.message === "processing_timeout") {
				this.setState({ errorMessage: TextManager.getText("score_process_failed") })
			}
			else if (error.message === "connection_error") {
				this.setState({ errorMessage: TextManager.getText("score_process_failed")  })
			}
			else {
				this.setState({ errorMessage: TextManager.getText("score_process_failed") })
			}
			//alert(error) //TODO: proper error handling
			return false;
		} finally {
			this.setState({
				showProcessingDialog: false
			});
		}
	}

	getProgressText = (data) => {
		switch (data.status) {
			case "recieved":
				return TextManager.getText("score_process_starting");
			case "deskewing":
				return TextManager.getText("score_process_preprocessing");
			case "omr":
			case "processing_sheets":
				return TextManager.getText("score_process_omr");
			case "midi_conversion":
				return TextManager.getText("score_process_midi_conversion");
			case "done":
			case "success":
				return TextManager.getText("score_process_displaying");
			case "error":
				return TextManager.getText("score_process_server_error");
			default:
				//console.log(data)
				//console.trace()
				return ""
		}
	}

	sendProcessPdfRequest = async (pdfFile) => {
		var formData = new FormData();
		formData.append("pdf", pdfFile)
		let success =  await this.sendProcessingRequest("/api/process-pdf", formData)
		// if (success) {
		// 	//this.props.close();
		// }
		// else {
		// 	this.setState({ errorMessage: TextManager.getText("score_process_pdf_failed") })
		// }
        return success;
	};

	sendProcessMxlRequest = async (musicXmlFile) => {
		SheetMusicPlayer.singleton.stop();

		if(! await this.waitForNewScoreConfirmDialog()){
			return false;
		}

		this.setState({
			showProcessingDialog: true
		});

		try {
			var formData = new FormData();
			formData.append("mxl", musicXmlFile);

			formData.append("mergeTracks", settingSystem.getSetting("mergeTracksOption"));
			formData.append("usePreprocessing", settingSystem.getSetting("usePreprocessing"))

			this.setState({
				progressText: TextManager.getText("processing"),
				progressPageNumber: undefined,
				progressStepPercentage: undefined,
				progressTotalPercentage: undefined,
			});

			const res = await axios.post(`/api/process-mxl`, formData,
				{
					headers: { 'content-type': 'multipart/form-data' },
					responseType: 'arraybuffer'
				}
			);
			let data = cbor.decode(res.data);
			await SheetMusicPlayer.singleton.loadData(data);			
			//this.props.close();
            return true;
		} catch (error) {
			console.log(error);
			this.setState({ errorMessage: TextManager.getText("score_process_xml_failed") })
            return false;
		} finally {
			this.setState({
				showProcessingDialog: false
			});
		}

	};



	
	waitForNewScoreConfirmDialog = () => {
		return new Promise(resolve => {
			if(this.props.welcomePageOpened){
				resolve(true);
				
			}
			else{
				this.newScoreConfirmDialogResolver = resolve;
				this.setState({newScoreConfirmDialogOpened: true});
			}
		});
	}

	render() {

        return <span>
        <Dialog open={this.state.showProcessingDialog} >
        {/* <Dialog open={true} > */}
            <Box sx={{
                margin: "30px 50px",
            }}>
                <Stack spacing={2} direction="column" justifyContent="center" alignItems="center">
                    <CircularProgress disableShrink />
                    {/* <Stack spacing={0} direction="column" justifyContent="center" alignItems="center">
                        <Typography>Displaying score</Typography>
                        <Typography>10%</Typography>
                    </Stack> */}

                    <Stack spacing={-1} direction="column" justifyContent="center" alignItems="center">
                        <Typography>{this.state.progressText}</Typography>
                        <Typography>{this.state.progressTotalPercentage != null ? "\t " + Math.floor(this.state.progressTotalPercentage) + "%" : null}</Typography>
                    </Stack>

                    {/* <Typography>
                        {this.state.progressPageNumber != null ? "Page " + this.state.progressPageNumber + ": " : null}
                        {this.state.progressStepPercentage != null ? "\t " + Math.floor(this.state.progressStepPercentage) + "%" : null}
                    </Typography> */}
                    {/* Processing... */}
                    
                </Stack>
            </Box>
        </Dialog>
        <Dialog open={this.state.errorMessage != null} >
            <Box sx={{
                margin: "50px 50px",
            }}>
                <Stack spacing={1} direction="column" justifyContent="center" alignItems="center">
                    <ErrorIcon />
                    <Typography>{this.state.errorMessage}</Typography>
                    <Button onClick={() => this.setState({ errorMessage: null })} variant="contained">Close</Button>
                </Stack>
            </Box>
        </Dialog>

            <Dialog
                open={this.state.newScoreConfirmDialogOpened}
                onClose={() => {}}
            >
                <DialogContent>
                    {/* <DialogContentText> */}
                        <Typography>
                            {TextManager.getText("load_new_score_confirm")}
                        </Typography>
                    {/* </DialogContentText> */}
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => {
                        this.setState({newScoreConfirmDialogOpened: false});
						this.newScoreConfirmDialogResolver(true);
                    }}>{TextManager.getText("confirm")}</Button>
                    
                    <Button variant="outlined" onClick={()=>{
                        this.setState({newScoreConfirmDialogOpened: false});
						this.newScoreConfirmDialogResolver(false);
                    }} autoFocus>{TextManager.getText("cancel")}</Button>
                </DialogActions>
            </Dialog>
        </span>
    }



}